import { getApplicationDomain } from '../constants/apiEnvironments';
export const getPortalHomeUrl = (portalId, hublet) => {
  return `${getApplicationDomain(hublet)}/home?portalId=${portalId}`;
};